const roomTypePackageUpgrade = [
  'single_regular',
  'single_vip',
  'single_platinum',
  'twin_regular',
  'twin_vip',
  'twin_platinum',
]

export function hasRoomTypePackageUpgrade(roomType: Tours.V2OfferRoomType | undefined) {
  return roomTypePackageUpgrade.includes(roomType ?? '')
}
